const STATUSES_EN = {
  added: "Added",
  archived: "archived",
  canceled: "Canceled",
  complete: "Complete",
  confirmed: "To come",
  ended: "Ended",
  expired: "Expired",
  expires_soon: "Expires soon",
  incomplete: "Incomplete",
  paid: "Paid",
  paymentToCome: "Payment to come",
  pending: "Pending",
  proposed: "Proposed",
  refused: "Refused",
  scheduled: "To be processed",
  sent: "To be processed",
  started: "Started",
  to_add: "To add",
  to_renew: "To renew",
  toAdd: "To add",
  toCome: "To come",
  toCorrect: "To correct",
  toJustify: "To justify",
  toPay: "To pay",
  up_to_date: "Up to date",
  validated: "Validated",
  validationInProgress: "Validation in progress",
  waiting_for_confirmation: "To come",
  waiting_for_validation: "In progress",
} as const;

export default STATUSES_EN;
